import { useMemo } from 'react'
import { FilterDrawerType } from '@/components/CourseFiltersDrawer/types'
import { useFetchFilterCategoriesQuery } from '@/store/api/filterCategoriesApi'
import { useAppSelector } from '@/store/hooks'
import { createFiltersSelector } from '@/store/slices/aggregatesSlice'
import { isOpenCatalog } from '@/utils/isOpenCatalog'

export const useFilterCategories = (filterType: FilterDrawerType) => {
  const { data: filterCategories = [], isLoading } = useFetchFilterCategoriesQuery(filterType, {
    skip: isOpenCatalog(),
  })

  const categoryFilters = useAppSelector((state) => createFiltersSelector(state, filterType).category)

  return useMemo(() => {
    return {
      isLoading,
      filterCategories: isLoading
        ? []
        : filterCategories.map((filterCategory) => ({
            ...filterCategory,
            isActive: categoryFilters && categoryFilters[filterCategory.id]?.length > 0,
            attributes:
              filterCategory.attributes?.map((attribute) => ({
                ...attribute,
                isActive: (categoryFilters && categoryFilters[filterCategory.id]?.includes(attribute.id)) || false,
              })) || [],
          })),
    }
  }, [isLoading, filterCategories, categoryFilters])
}
